import { Outlet } from 'react-router';
import { ScrollProgress } from '~/components/custom/scroll-progress';
import { SiteFooter } from '~/components/custom/site-footer';
import { SiteNav } from '~/components/custom/site-nav';
import { getClinics, getStates } from '~/services/content.server';

/**
 * The states and sites every page's chrome needs: the footer lists every
 * location, and the organization markup on every page names the live states
 * (read back out of `matches` by `lib/meta.ts`). One loader, rather than each
 * route fetching them, and it does not re-run on client navigations because the
 * layout's params never change.
 */
export async function loader() {
  const [states, sites] = await Promise.all([getStates(), getClinics()]);
  return {
    states: states.map(({ code, slug, name_en, name_es, status }) => ({ code, slug, name_en, name_es, status })),
    sites: sites.map(({ slug, kind, name_en, name_es, address_line1, address_line2, city, state, postal_code }) => ({
      slug,
      kind,
      name_en,
      name_es,
      address_line1,
      address_line2,
      city,
      state,
      postal_code,
    })),
  };
}

// Page shell lives here, once — routes return only content fragments
// (no <main> wrapper, no nav/footer imports). See docs in the design kit.
export default function SiteLayout() {
  return (
    <div data-theme="academy-customer" className="flex min-h-screen flex-col bg-background text-foreground">
      <ScrollProgress />
      <SiteNav />
      <main id="main-content" tabIndex={-1} className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
